import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import ReactHtmlParser from 'react-html-parser';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import { Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, Alert, Table } from 'reactstrap';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// Actions
import { getPriorityOrders, getSpecPriorityOrders, getArchivePriorityOrders, getHistoryData } from '../../store/priority/actions';
import { onUpdatePriorityOrder } from '../../app-socket/events/priority';
// Helpers
import { countryOptions } from '../../helpers/country_helper';
// Components
import PageLoader from '../../components/Loaders/pageLoader';
import Breadcrumbs from '../../components/Breadcrumb';
// import TrackingColumn from '../../components/TrackingColumn';
import TrackingColumnPrTest from '../../components/TrackingColumnPrTest';
import { allowedDepartments } from '../../helpers/currency_helper';
// Pages Components
import FilterPrComp from './filter';
import { socket } from '../../app-socket/socket';
import { WsEvents } from '../../app-socket/events';

class PriorityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      my_priority_orders: [],
      archive_priority_orders: [],
      alert: null,
      invoiceNo: null,
      modalOrderHistory: false,
      progress: { step: 'Completed', time: 100 },
      PriorityListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          csvExport: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'ID',
          dataField: 'testField',
          sort: true,
          csvExport: false,
          hidden: true
        },
        {
          text: 'Pay Date',
          dataField: 'paymentDate',
          sort: true,
          editable: false,
          csvExport: true,
          csvFormatter: (cell, row, rowIndex) => row.paymentDate !== null && new Date(row.paymentDate).toLocaleDateString('en-GB'),
          formatter: (cellContent, priority_order) => <h5 className='font-size-16 mb-1'>{new Date(priority_order.paymentDate).toLocaleDateString('en-GB')}</h5>
        },
        {
          text: 'Order №',
          dataField: 'invoiceNo',
          sort: true,
          editable: false,
          formatter: (cellContent, priority_order) => (
            <h5 className={priority_order.importantOrder === true ? 'font-size-16 mb-1 important-order-color' : 'font-size-16 mb-1'}>{priority_order.invoiceNo} </h5>
          )
        },
        {
          text: 'Client Name',
          dataField: 'client_info.clientName',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.client_info && row.client_info.clientName,
          formatter: (cellContent, priority_order) => <h5 className='font-size-16 name-width mb-1'>{priority_order.client_info && priority_order.client_info.clientName}</h5>
        },
        {
          text: 'Manager',
          dataField: 'manager.fname',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.manager && `${row.manager.fname} ${row.manager.sname}`,
          formatter: (cellContent, priority_order) => (
            <div className='slname-width'>
              {this.props.profileData.department.depName !== 'Logistics/Warehouse KR' ? (
                <h5 className='font-size-16 mb-1'>
                  <span>
                    <div>
                      {!priority_order.manager.profilePic ? (
                        <div className='avatar-sm m-2 d-inline-block'>
                          <span className='avatar-title rounded-circle'>{priority_order.manager.fname.charAt(0)}</span>
                        </div>
                      ) : (
                        <img className='rounded-circle avatar-sm m-2' src={priority_order.manager.profilePic} alt='profile pic' />
                      )}
                      <span>
                        {priority_order.manager.fname} {priority_order.manager.sname}
                      </span>
                    </div>
                  </span>
                </h5>
              ) : (
                <h5 className='font-size-16 mb-1'>
                  {priority_order.manager.fname} {priority_order.manager.sname}
                </h5>
              )}
            </div>
          )
        },
        {
          text: 'WH Manager ',
          dataField: 'whManager',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.whManager && `${row.whManager.fname} ${row.whManager.sname}`,
          formatter: (cellContent, priority_order) => (
            <div className='form-group'>
              <select
                className='form-control wh-manager-selection'
                name='whManager'
                value={priority_order.whManager ? priority_order.whManager._id : ''}
                onChange={(e) => this.handleEditOrderClick(e, 'manager', priority_order)}
                disabled={this.props.profileData.department.depName !== 'Logistics/Warehouse KR' || priority_order.completedOrder || priority_order.toWH}
              >
                <option value='select' className='alert-primary'>
                  {priority_order.toWH ? 'To WH' : 'Select'}
                </option>
                {/* <option value={priority_order.whManager ? priority_order.whManager._id : 'select'} className='alert-primary'>{priority_order.whManager ? priority_order.whManager.fname+' '+priority_order.whManager.sname : 'Select'}</option> */}
                {this.props.wh_managers.map((manager, index) => {
                  return (
                    <option key={index} value={manager._id}>
                      {' '}
                      {manager.fname} {manager.sname}{' '}
                    </option>
                  );
                })}
              </select>
            </div>
          )
        },
        {
          text: <i data-tip='Package Started' className='mdi mdi-package-variant font-size-24'></i>,
          dataField: 'pckStarted',
          editable: false,
          csvFormatter: (cell, row, rowIndex) => (row.pckStarted === true ? 'yes' : 'no'),
          formatter: (cellContent, priority_order) => (
            <div className='form-check'>
              <input
                className='form-check-input'
                name='pckStarted'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'checkbox', priority_order)}
                disabled={priority_order.whManager === null || this.props.profileData.department.depName !== 'Logistics/Warehouse KR' || (priority_order.completedOrder === true && true)}
                value={priority_order.pckStarted}
                defaultChecked={priority_order.pckStarted}
              />
            </div>
          )
        },
        {
          text: <i className='mdi mdi-package-variant-closed font-size-24' data-tip='Package Completed'></i>,
          dataField: 'pckCompleted',
          editable: false,
          csvFormatter: (cell, row, rowIndex) => (row.pckCompleted === true ? 'yes' : 'no'),
          formatter: (cellContent, priority_order) => (
            <div className='form-check'>
              <input
                className='form-check-input'
                name='pckCompleted'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'checkbox', priority_order)}
                disabled={priority_order.whManager === null || this.props.profileData.department.depName !== 'Logistics/Warehouse KR' || (priority_order.completedOrder === true && true)}
                value={priority_order.pckCompleted}
                defaultChecked={priority_order.pckCompleted}
              />
            </div>
          )
        },
        {
          text: <i className='mdi mdi-file-document-outline font-size-24' data-tip='Docs Ready'></i>,
          dataField: 'docsReady',
          editable: false,
          csvFormatter: (cell, row, rowIndex) => (row.docsReady === true ? 'yes' : 'no'),
          formatter: (cellContent, priority_order) => (
            <div className='form-check'>
              <input
                className='form-check-input'
                name='docsReady'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'checkbox', priority_order)}
                disabled={
                  (this.props.profileData.department.depName !== 'Sales Department' && this.props.profileData.department.depName !== 'Business Management Team') ||
                  (priority_order.completedOrder === true && true)
                }
                value={priority_order.docsReady}
                defaultChecked={priority_order.docsReady}
              />
            </div>
          )
        },
        {
          text: <i className='mdi mdi-calendar-check font-size-24' data-tip='Booked Pickup'></i>,
          dataField: 'bookedPickup',
          editable: false,
          csvFormatter: (cell, row, rowIndex) => (row.bookedPickup === true ? 'yes' : 'no'),
          formatter: (cellContent, priority_order) => (
            <div className='form-check'>
              {/* <input
                className='form-check-input'
                name='bookedPickup'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'checkbox', priority_order)}
                disabled={
                  priority_order.whManager === null ||
                  (this.props.profileData.department.depName !== 'Logistics/Warehouse KR' && this.props.profileData.department.depName !== 'Business Management Team') ||
                  (priority_order.onHold === true && true)
                }
                value={priority_order.bookedPickup}
                defaultChecked={priority_order.bookedPickup}
              /> */}
              <input
                className='form-check-input'
                name='bookedPickup'
                type='checkbox'
                checked={!!priority_order.bookedPickup}
                onChange={(e) => this.handleEditOrderClick(e, 'pickup', priority_order)}
                disabled={
                  priority_order.whManager === null ||
                  (this.props.profileData.department.depName !== 'Logistics/Warehouse KR' && this.props.profileData.department.depName !== 'Business Management Team') ||
                  (priority_order.onHold === true && true)
                }
              />
            </div>
          )
        },
        {
          text: <i className='fas fa-shipping-fast font-size-20' data-tip='Ready to ship'></i>,
          dataField: 'readyToShip',
          editable: false,
          csvFormatter: (cell, row, rowIndex) => (row.readyToShip === true ? 'yes' : 'no'),
          formatter: (cellContent, priority_order) => (
            <div className='form-check'>
              <input
                className='form-check-input'
                name='readyToShip'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'completed', priority_order)}
                disabled={
                  priority_order.whManager === null ||
                  (this.props.profileData.department.depName !== 'Logistics/Warehouse KR' && this.props.profileData.department.depName !== 'Business Management Team') ||
                  (priority_order.onHold === true && true)
                }
                value={priority_order.readyToShip}
                defaultChecked={priority_order.readyToShip}
              />
              {/* <input
                className='form-check-input'
                name='readyToShip'
                type='checkbox'
                checked={!!priority_order.readyToShip}
                onChange={(e) => this.handleEditOrderClick(e, 'completed', priority_order)}
                // disabled={
                //   priority_order.whManager === null ||
                //   (this.props.profileData.department.depName !== 'Logistics/Warehouse KR' && this.props.profileData.department.depName !== 'Business Management Team') ||
                //   (priority_order.onHold === true && true)
                // }
              /> */}
            </div>
          )
        },
        {
          text: 'Logistic Comments',
          dataField: 'logisticCom',
          sort: true,
          csvFormatter: (cell, row, rowIndex) => row.logisticCom,
          editable: (cell, row, rowIndex, colIndex) => {
            let editable_value = true;
            this.props.profileData.department.depName !== 'Business Management Team' ? (editable_value = false) : (editable_value = true);
            return editable_value;
          },
          formatter: (cellContent, priority_order) => (
            <div className='name-width'>
              <p className=' mb-0'>{priority_order.logisticCom}</p>
            </div>
          )
        },
        {
          text: 'Pack Date',
          dataField: 'packingDate',
          sort: true,
          editable: false,

          formatter: (cellContent, priority_order) => (
            <>
              {priority_order.packingDate && (
                <h5 className='font-size-16 mb-1'>
                  {priority_order.packingDate.includes('-00')
                    ? priority_order.packingDate.split('-')[2].replace('00', '..') + '/' + priority_order.packingDate.split('-')[1] + '/' + priority_order.packingDate.split('-')[0]
                    : priority_order.packingDate.includes('-')
                    ? new Date(priority_order.packingDate).toLocaleDateString('en-GB')
                    : priority_order.packingDate}
                </h5>
              )}
            </>
          )
        },
        {
          text: 'Ship Date',
          dataField: 'sendDate',
          sort: true,
          editable: false,
          formatter: (cellContent, priority_order) => (
            <h5 className='font-size-16 mb-1'>
              {priority_order.sendDate.includes('-00')
                ? priority_order.sendDate.split('-')[2].replace('00', '..') + '/' + priority_order.sendDate.split('-')[1] + '/' + priority_order.sendDate.split('-')[0]
                : priority_order.sendDate.includes('-')
                ? new Date(priority_order.sendDate).toLocaleDateString('en-GB')
                : priority_order.sendDate}
            </h5>
          )
        },
        {
          text: 'Delivery Service',
          dataField: 'delService',
          sort: true,
          // editable: this.props.profileData.department.depName === 'Business Management Team' ? true: false,
          csvFormatter: (cell, row, rowIndex) => row.delService,
          formatter: (cellContent, priority_order) => (
            <div className='name-width pt-1 pb-1'>
              <div className='p-0'>
                {priority_order.delService} {priority_order.official === true && '/ Official '}
              </div>
              <div className={priority_order.toxThrPackaged ? 'mb-0 packed' : 'mb-0'}>
                {(priority_order.toxins || priority_order.threads) && (
                  <span className={priority_order.completedOrder || priority_order.onHold ? 'disabled text-dark ms-2' : 'text-dark ms-2'}>
                    {priority_order.toxins && '/ Toxins '}
                    {priority_order.threads && '/ Threads '}
                    <i
                      className={priority_order.toxThrPackaged ? 'mdi mdi-package-variant-closed font-size-22' : 'mdi mdi-package-variant font-size-22'}
                      id='edittooltip'
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        if (priority_order.completedOrder || priority_order.onHold) return;
                        e.stopPropagation();
                        const dep = this.props.profileData.department.depName;
                        if (dep === 'Business Management Team' || dep === 'Logistics/Warehouse KR') {
                          this.handleEditOrderClick(e, 'toxThrPackaged', priority_order);
                        }
                      }}
                    ></i>
                  </span>
                )}
              </div>
              <div className={priority_order.qrScanned ? 'mb-0 scanned' : 'mb-0'}>
                {priority_order.qr && (
                  <span className={priority_order.completedOrder || priority_order.onHold ? 'disabled text-dark ms-2' : 'text-dark ms-2'}>
                    {priority_order.qr && '/ QR '}
                    <i
                      className={priority_order.qrScanned ? 'mdi mdi-qrcode-scan font-size-22' : 'mdi mdi-qrcode font-size-22'}
                      id='edittooltip'
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        if (priority_order.completedOrder || priority_order.onHold) return;
                        e.stopPropagation();
                        const dep = this.props.profileData.department.depName;
                        if (dep === 'Business Management Team' || dep === 'Logistics/Warehouse KR') {
                          this.handleEditOrderClick(e, 'qrScanned', priority_order);
                        }
                      }}
                    ></i>
                  </span>
                )}
              </div>
            </div>
          )
        },
        {
          text: 'Tracking Number',
          dataField: 'delInfo.trackingNo',
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          hidden: allowedDepartments.includes(this.props.profileData?.department?.depName) ? false : true,
          formatter: (cellContent, priority_order) => <TrackingColumnPrTest tableData={priority_order} option='logistic' />
        },
        {
          text: 'Item Status',
          dataField: 'managerCom',
          sort: true,
          // editable: false,
          csvFormatter: (cell, row, rowIndex) => row.managerCom,
          formatter: (cellContent, priority_order) => (
            <div className='name-width'>
              <p className=' mb-0'>{priority_order.lockReason !== '' && priority_order.lockReason ? priority_order.lockReason : priority_order.managerCom}</p>
            </div>
          )
        },
        {
          dataField: 'menu',
          isDummyField: true,
          csvExport: false,
          text: 'Action',
          editable: false,
          formatter: (cellContent, priority_order) => (
            <div className='d-flex gap-3'>
              {this.props.profileData.permissions.includes('priorityBtnNewOrderAccess') && (
                <>
                  <Link className='text-info' to='#'>
                    <i className='mdi mdi-content-copy font-size-18' id='edittooltip' onClick={() => this.handleCopyOrderClick(priority_order)}></i>
                  </Link>
                  <Link className={priority_order.completedOrder ? 'disabled text-success' : 'text-success'} to='#'>
                    <i className='mdi mdi-pencil font-size-18' id='edittooltip' onClick={(e) => this.handleEditOrderClick(e, 'not checkbox', priority_order)}></i>
                  </Link>
                </>
              )}
              <Link className={priority_order.bookedPickup || priority_order.completedOrder ? 'disabled text-primary' : 'text-primary'} to='#'>
                {priority_order.lockedBy && 'Hold by ' + priority_order.lockedBy.fname + ' ' + priority_order.lockedBy.sname}
                <i
                  className={priority_order.onHold ? 'mdi mdi-lock font-size-18' : 'mdi mdi-lock-open-outline font-size-18'}
                  id='holdtooltip'
                  data-tip={priority_order.lockedBy && 'Hold by ' + priority_order.lockedBy.fname + ' ' + priority_order.lockedBy.sname}
                  onClick={(e) => this.handleEditOrderClick(e, 'locked', priority_order)}
                ></i>
              </Link>
              {this.props.profileData.permissions.includes('priorityBtnNewOrderAccess') && (
                <Link className={priority_order.completedOrder === true ? 'disabled text-danger' : 'text-danger'} to='#'>
                  <i className='mdi mdi-delete font-size-18' id='deletetooltip' onClick={() => this.handleDeletePriorityOrder(priority_order)}></i>
                </Link>
              )}
              {priority_order.transferAgentSent === true && priority_order.pckCompleted === true && (
                <Link
                  className='text-warning'
                  to={{
                    pathname: '/transfers',
                    state: { invoiceNoFromPriority: priority_order.invoiceNo }
                  }}
                >
                  <i className='fas fa-people-arrows font-size-16' id='edittooltip'></i>
                </Link>
              )}
              {(this.props.profileData.permissions.includes('priorityHistoryBtnAccess') || this.props.profileData.accType === 'Admin') && (
                <Link className='text-dark' to='#'>
                  <i className='mdi mdi-history me-1' onClick={() => this.viewOrderHistory(priority_order)} />
                </Link>
              )}
            </div>
          )
        }
      ],
      ArchiveListColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          csvExport: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Payment Date',
          dataField: 'paymentDate',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.paymentDate !== null && new Date(row.paymentDate).toLocaleDateString('en-GB'),
          formatter: (cellContent, archive_order) => <h5 className='font-size-16 mb-1'>{new Date(archive_order.paymentDate).toLocaleDateString('en-GB')}</h5>
        },
        {
          text: 'Order №',
          dataField: 'invoiceNo',
          sort: true,
          editable: false,
          csvExport: true,
          formatter: (cellContent, archive_order) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1'>{archive_order.invoiceNo}</h5>
            </div>
          )
        },
        {
          text: 'Client Name',
          dataField: 'client_info',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.client_info && row.client_info.clientName,
          formatter: (cellContent, archive_order) => <h5 className='font-size-16 name-width mb-1'>{archive_order.client_info && archive_order.client_info.clientName}</h5>
        },
        {
          text: 'Manager',
          dataField: 'manager',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.manager && `${row.manager.fname} ${row.manager.sname}`,
          formatter: (cellContent, archive_order) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1'>
                {archive_order.manager.fname} {archive_order.manager.sname}
              </h5>
            </div>
          )
        },
        {
          text: 'WH Manager',
          dataField: 'whManager',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.whManager && `${row.whManager.fname} ${row.whManager.sname}`,
          formatter: (cellContent, archive_order) => (
            <div className='name-width'>
              <h5 className='font-size-16 mb-1'>
                {archive_order.whManager ? (
                  <span>
                    {archive_order.whManager.fname} {archive_order.whManager.sname}
                  </span>
                ) : null}
              </h5>
            </div>
          )
        },
        {
          text: 'Package Started',
          dataField: 'pckStarted',
          sort: true,
          editable: false,
          headerClasses: 'vertical-text',
          csvFormatter: (cell, row, rowIndex) => (row.pckStarted === true ? 'yes' : 'no'),
          formatter: (cellContent, archive_order) => (
            <div className='form-check'>
              <input className='form-check-input' name='pckStarted' type='checkbox' disabled={true} value={archive_order.pckStarted} defaultChecked={archive_order.pckStarted} />
            </div>
          )
        },
        {
          text: 'Package Completed',
          dataField: 'pckCompleted',
          sort: true,
          editable: false,
          headerClasses: 'vertical-text',
          csvFormatter: (cell, row, rowIndex) => (row.pckCompleted === true ? 'yes' : 'no'),
          formatter: (cellContent, archive_order) => (
            <div className='form-check'>
              <input className='form-check-input' name='pckCompleted' type='checkbox' disabled={true} value={archive_order.pckCompleted} defaultChecked={archive_order.pckCompleted} />
            </div>
          )
        },
        {
          text: 'Docs Ready',
          dataField: 'docsReady',
          sort: true,
          editable: false,
          headerClasses: 'vertical-text',
          csvFormatter: (cell, row, rowIndex) => (row.docsReady === true ? 'yes' : 'no'),
          formatter: (cellContent, archive_order) => (
            <div className='form-check'>
              <input className='form-check-input' name='docsReady' type='checkbox' disabled={true} value={archive_order.docsReady} defaultChecked={archive_order.docsReady} />
            </div>
          )
        },
        {
          text: 'Booked Pickup',
          dataField: 'bookedPickup',
          sort: true,
          editable: false,
          headerClasses: 'vertical-text',
          csvFormatter: (cell, row, rowIndex) => (row.bookedPickup === true ? 'yes' : 'no'),
          formatter: (cellContent, archive_order) => (
            <div className='form-check'>
              <input
                className='form-check-input'
                name='bookedPickup'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'completed', archive_order)}
                disabled={
                  (this.props.profileData.department.depName !== 'Logistics/Warehouse KR' && this.props.profileData.department.depName !== 'Business Management Team') ||
                  (archive_order.onHold === true && true)
                }
                value={archive_order.bookedPickup}
                defaultChecked={archive_order.bookedPickup}
              />
            </div>
          )
        },
        {
          text: 'Ready to Ship',
          dataField: 'readyToShip',
          sort: true,
          editable: false,
          headerClasses: 'vertical-text',
          csvFormatter: (cell, row, rowIndex) => (row.readyToShip === true ? 'yes' : 'no'),
          formatter: (cellContent, archive_order) => (
            <div className='form-check'>
              <input
                className='form-check-input'
                name='readyToShip'
                type='checkbox'
                onChange={(e) => this.handleEditOrderClick(e, 'completed', archive_order)}
                disabled={
                  (this.props.profileData.department.depName !== 'Logistics/Warehouse KR' && this.props.profileData.department.depName !== 'Business Management Team') ||
                  (archive_order.onHold === true && true)
                }
                value={archive_order.readyToShip}
                defaultChecked={archive_order.readyToShip}
              />
            </div>
          )
        },
        {
          text: 'Logistic Comments',
          dataField: 'logisticCom',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.logisticCom,
          formatter: (cellContent, archive_order) => (
            <div className='name-width'>
              <p className=' mb-0'>{archive_order.logisticCom}</p>
            </div>
          )
        },
        {
          text: 'Pack Date',
          dataField: 'packingDate',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.sendDate,
          formatter: (cellContent, archive_order) => (
            <>
              {archive_order.packingDate && (
                <h5 className='font-size-16 mb-1'>
                  {archive_order.packingDate.includes('-00')
                    ? archive_order.packingDate.split('-')[2].replace('00', '..') + '/' + archive_order.packingDate.split('-')[1] + '/' + archive_order.packingDate.split('-')[0]
                    : archive_order.packingDate.includes('-')
                    ? new Date(archive_order.packingDate).toLocaleDateString('en-GB')
                    : archive_order.packingDate}
                </h5>
              )}
            </>
          )
        },
        {
          text: 'Send Date',
          dataField: 'sendDate',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.sendDate,
          formatter: (cellContent, archive_order) => <h5 className='font-size-16 mb-1'>{archive_order.sendDate}</h5>
        },
        {
          text: 'Delivery Service',
          dataField: 'delService',
          sort: true,
          editable: this.props.profileData.department.depName === 'Business Management Team' ? true : false,
          csvFormatter: (cell, row, rowIndex) => row.delService,
          formatter: (cellContent, archive_order) => (
            <div className='name-width'>
              <p className='mb-0'>
                {archive_order.delService}
                {(archive_order.toxins === true || archive_order.threads === true) && (
                  <Link className={archive_order.completedOrder === true ? 'disabled text-dark ms-2' : archive_order.onHold === true ? 'disabled text-dark ms-2' : 'text-dark ms-2'} to='#'>
                    {' '}
                    {archive_order.toxins === true && '/Toxins '} {archive_order.threads === true && '/Threads '} {archive_order.official === true && '/Official '}
                    <i className={archive_order.toxThrPackaged === true ? 'mdi mdi-package-variant-closed font-size-22' : 'mdi mdi-package-variant font-size-22'} id='edittooltip'></i>
                  </Link>
                )}
              </p>
            </div>
          )
        },
        {
          text: 'Tracking Number',
          dataField: 'delInfo.trackingNo',
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          // hidden: this.props.profileData.department.depName !== 'Sales Department',
          formatter: (cellContent, archive_order) => <TrackingColumnPrTest tableData={archive_order} option='logistic' />
        },
        {
          text: 'Item Status',
          dataField: 'managerCom',
          sort: true,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => row.managerCom,
          formatter: (cellContent, archive_order) => (
            <div className='name-width'>
              <p className=' mb-0'>{archive_order.managerCom}</p>
            </div>
          )
        },
        {
          dataField: 'menu',
          isDummyField: true,
          csvExport: false,
          text: 'Action',
          editable: false,
          formatter: (cellContent, archive_order) => (
            <div className='d-flex gap-3'>
              {(this.props.profileData.permissions.includes('priorityHistoryBtnAccess') || this.props.profileData.accType === 'Admin') && (
                <Link className='text-dark' to='#'>
                  <i className='mdi mdi-history me-1' onClick={() => this.viewOrderHistory(archive_order)} />
                </Link>
              )}
            </div>
          )
        }
      ]
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.handleChildStateChange = this.handleChildStateChange.bind(this);
    this.child = React.createRef();
    this.rowClasses = this.rowClasses.bind(this);
    this.indication = this.indication.bind(this);
    this.loadArchive = this.loadArchive.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);

    this.handleCopyOrderClick = this.handleCopyOrderClick.bind(this);
    this.handleEditOrderClick = this.handleEditOrderClick.bind(this);
    this.viewOrderHistory = this.viewOrderHistory.bind(this);
    this.toggleHistoryOrderModal = this.toggleHistoryOrderModal.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }
  componentDidMount() {
    const { onGetPriorityOrders } = this.props;
    // if (profileData?.department?.depName === 'Cosmetic Brand-Suppuru') {
    //   const my_priority_orders = (priority_orders || []).filter(
    //     (order) => order.manager._id === profileData._id
    //   );

    //   this.setState({
    //     my_priority_orders: my_priority_orders.length
    //       ? my_priority_orders
    //       : [{ manager: 'No Results Found' }]
    //   });
    // }
    onGetPriorityOrders();
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
    // Join Priority Orders Room
    socket.emit(WsEvents.priority.JOIN_ROOM, console.log);
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
    // Leave Priority Orders Room
    socket.emit(WsEvents.priority.LEAVE_ROOM, console.log);
  }
  componentDidUpdate(prevProps, prevState, ss) {
    const { priority_orders, profileData } = this.props;
    const myOrdersCheckbox = document.getElementById('myOrders');

    if (this.props !== prevProps && myOrdersCheckbox && myOrdersCheckbox.checked === true) {
      const { priority_orders, profileData } = this.props;
      let my_priority_orders = [];
      priority_orders.map((order) => {
        if (order.manager._id === profileData._id) {
          my_priority_orders.push(order);
        }
        return my_priority_orders;
      });
      if (my_priority_orders.length === 0) {
        my_priority_orders.push({ manager: 'No Results Found' });
      }
      this.setState({ my_priority_orders: my_priority_orders });
    }
    // Only run if priority_orders or profileData changed
    if (profileData !== prevProps.profileData || priority_orders !== prevProps.priority_orders) {
      if (profileData?.department?.depName === 'Cosmetic Brand-Suppuru') {
        const my_priority_orders = (priority_orders || []).filter((order) => order.manager?._id === profileData._id);

        this.setState({
          my_priority_orders: my_priority_orders.length ? my_priority_orders : [{ manager: 'No Results Found' }]
        });
      }
    }
    if (prevProps.archive_priority_orders !== this.props.archive_priority_orders) {
      this.setState({ archive_priority_orders: this.props.archive_priority_orders });
    }
  }
  /**
   * get screen height to set it for table
   */
  getScreenHeight = (click) => {
    if (document.getElementById('card-section') !== null) {
      let screenHeight = document.getElementById('card-section').offsetHeight;
      document.querySelector('.react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - 120px); overflow: auto;');
    }
  };
  /**
   * Handle state change from child component
   * @param {*} option
   * @param {*} newState
   */
  handleChildStateChange = (option, newState) => {
    if (option === 'filter') {
      this.setState({ my_priority_orders: newState });
    } else if (option === 'loadArchive') {
      this.loadArchive(newState);
    } else if (option === 'reset_filter') {
      this.setState({ archive_priority_orders: newState });
    } else if (option === 'alert') {
      this.setState({ alert: newState });
    }
  };
  /**
   * @param {Arr} row
   * @param {Int} rowIndex
   * @returns class to selected rows
   */
  rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.onHold === true) {
      classes = 'on-hold-row';
    } else if (row.completedOrder === true || row.bookedPickup === true) {
      classes = 'completed-row';
    } else if (row.transferAgentSent === true && row.pckCompleted === true) {
      classes = 'transfer-row';
    } else if (row.toWH === true) {
      classes = 'work-done-row';
    }
    return classes;
  };
  /**
   * Display empty table
   * @returns
   */
  indication = () => {
    let { archive_priority_orders } = this.props;
    let { my_priority_orders } = this.state;
    let emptyMessage = '';
    if (
      (my_priority_orders.length !== 0 && my_priority_orders[0]['manager'] === 'No Results Found') ||
      (archive_priority_orders.length !== 0 && archive_priority_orders[0]['manager'] === 'No Results Found')
    ) {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };
  /**
   * Get 50 rows per page
   * @param {*} amount
   */
  loadArchive = (amount) => {
    const { onGetArchivePriorityOrders } = this.props;
    let data = { amount: amount };
    onGetArchivePriorityOrders(data);
  };
  /**
   * @param {String} oldValue
   * @param {String} newValue
   * @param {Arr} row
   * @param {String} column
   * @param {String} rowId
   * @returns saving data after editing is finsihed
   */
  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    if (oldValue === newValue) return;
    const { /*onUpdatePriorityOrder*/ dispatch, profileData } = this.props;
    setTimeout(() => {
      row[column.dataField] = newValue;
      const updatePriorityOrder = {
        _id: row._id,
        [column.dataField]: newValue,
        historyData: ''
      };
      const historyData = {
        order_id: row['_id'],
        manager: profileData.fname + ' ' + profileData.sname,
        updated: new Date().toLocaleString('en-GB'),
        action: `<b>${column.dataField === 'managerCom' ? 'Item Status' : 'Logistic Comments'}</b> value from <b>${oldValue}</b> to <b>${newValue}</b><br>`
      };
      updatePriorityOrder['historyData'] = historyData;
      // onUpdatePriorityOrder(updatePriorityOrder);
      onUpdatePriorityOrder({ dispatch, data: JSON.parse(JSON.stringify(updatePriorityOrder)) });

      // if (newValue !== oldValue) {
      const result = this.state.PriorityListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ PriorityListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };

  handleEditOrderClick = (e, type, priority_order) => this.child.current.handleEditOrderClick(e, type, priority_order);
  handleCopyOrderClick = (priority_order) => this.child.current.handleCopyOrderClick(priority_order);
  handleDeletePriorityOrder = (priority_order) => this.child.current.handleDeletePriorityOrder(priority_order);
  /**
   * View changes history for selected order
   * @param {*} data
   */
  viewOrderHistory = (order) => {
    const { onGetHistoryData } = this.props;
    this.setState({ invoiceNo: order.invoiceNo });
    onGetHistoryData(order._id);
    this.toggleHistoryOrderModal();
  };
  toggleHistoryOrderModal = () => this.setState((prevState) => ({ modalOrderHistory: !prevState.modalOrderHistory }));

  hideAlert = () => this.setState({ alert: null });
  render() {
    const { priority_orders, history_data, profileData, count, loading } = this.props;
    console.log(this.props);
    const { PriorityListColumns, ArchiveListColumns, my_priority_orders, archive_priority_orders, modalOrderHistory, invoiceNo, alert, progress } = this.state;
    const pageOptions = {
      sizePerPage:
        my_priority_orders.length !== 0 && my_priority_orders[0]['manager'] === 'No Results Found'
          ? 0
          : my_priority_orders.length !== 0
          ? my_priority_orders.length
          : archive_priority_orders.length !== 0 && archive_priority_orders[0]['manager'] === 'No Results Found'
          ? 0
          : archive_priority_orders.length !== 0
          ? 100
          : priority_orders.length,
      totalSize:
        my_priority_orders.length !== 0 && my_priority_orders[0]['manager'] === 'No Results Found'
          ? 0
          : my_priority_orders.length !== 0
          ? my_priority_orders.length
          : archive_priority_orders.length !== 0 && archive_priority_orders[0]['manager'] === 'No Results Found'
          ? 0
          : archive_priority_orders.length !== 0
          ? count
          : priority_orders.length,
      custom: true
    };
    const defaultSorted = [
      {
        dataField: 'testField', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];
    const selectRow = {
      mode: 'checkbox'
    };
    const notifData = my_priority_orders.length !== 0 && my_priority_orders[0]['manager'] === 'No Results Found'
                      ? []
                      : my_priority_orders.length !== 0
                      ? my_priority_orders
                      : archive_priority_orders.length !== 0 && archive_priority_orders[0]['manager'] === 'No Results Found'
                      ? []
                      : archive_priority_orders.length !== 0
                      ? archive_priority_orders
                      : priority_orders
                              
    return (
      <React.Fragment>
        {/* {loading && <PageLoader />} */}
        {loading && <PageLoader progress={progress} isLoading={loading} />}
        <div className='page-content'>
          <MetaTags>
            <title>Priority Korea</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('priorityOrderAccess') ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title='Korupharma' breadcrumbItem='Priority Korea' pg='pr' />
                <Row id='card-section'>
                  <Col lg='12'>
                    <Card>
                      <CardBody className='cardBodySticky'>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField='_id'
                          columns={archive_priority_orders.length !== 0 ? ArchiveListColumns : my_priority_orders.length !== 0 ? PriorityListColumns : PriorityListColumns}
                          data={
                            my_priority_orders.length !== 0 && my_priority_orders[0]['manager'] === 'No Results Found'
                              ? []
                              : my_priority_orders.length !== 0
                              ? my_priority_orders
                              : archive_priority_orders.length !== 0 && archive_priority_orders[0]['manager'] === 'No Results Found'
                              ? []
                              : archive_priority_orders.length !== 0
                              ? archive_priority_orders
                              : priority_orders
                          }
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField='_id'
                              columns={archive_priority_orders.length !== 0 ? ArchiveListColumns : my_priority_orders.length !== 0 ? PriorityListColumns : PriorityListColumns}
                              data={
                                my_priority_orders.length !== 0 && my_priority_orders[0]['manager'] === 'No Results Found'
                                  ? []
                                  : my_priority_orders.length !== 0
                                  ? my_priority_orders
                                  : archive_priority_orders.length !== 0 && archive_priority_orders[0]['manager'] === 'No Results Found'
                                  ? []
                                  : archive_priority_orders.length !== 0
                                  ? archive_priority_orders
                                  : priority_orders
                              }
                              search
                              exportCSV={{ fileName: 'Priority.csv', noAutoBOM: false, blobType: 'data:text/csv;charset=KOI8-RU' }}
                            >
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <FilterPrComp
                                    props={this.props}
                                    ref={this.child}
                                    notifData={notifData}
                                    toolkitprops={toolkitprops}
                                    PriorityListColumns={PriorityListColumns}
                                    countryOptions={countryOptions}
                                    onStateChange={this.handleChildStateChange}
                                    hideAlert={this.hideAlert}
                                  />
                                  <Row id='table-section'>
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      selectRow={selectRow}
                                      defaultSorted={defaultSorted}
                                      classes={'table align-middle table-nowrap'}
                                      headerClasses='header-class is-sticky-hdr'
                                      id='tableScroll'
                                      cellEdit={cellEditFactory({
                                        mode: 'click',
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell
                                      })}
                                      rowClasses={this.rowClasses}
                                      bordered={true}
                                      filter={filterFactory()}
                                      noDataIndication={this.indication}
                                      responsive
                                    />

                                    {/* Vie order history modal  */}
                                    <Modal size='xl' isOpen={modalOrderHistory} className={this.props.className} toggle={this.toggleHistoryOrderModal}>
                                      <ModalHeader toggle={this.toggleHistoryOrderModal} tag='h4'>
                                        Archive changes for order #{invoiceNo}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Table striped bordered hover>
                                          <thead>
                                            <tr>
                                              <th>Manager</th>
                                              <th>Action</th>
                                              <th>Time</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {history_data.map((action, index) => {
                                              return (
                                                <tr key={index}>
                                                  <td>{action.manager}</td>
                                                  <td>
                                                    {action.action.includes('Created this order') || action.action.includes('Created new order') ? (
                                                      <> Order was created </>
                                                    ) : (
                                                      <>
                                                        {action.action.includes('<br>') ? (
                                                          action.action
                                                            .split('<br>')
                                                            .slice(0, -1)
                                                            .map((act, key) => {
                                                              return (
                                                                <p key={key}>
                                                                  Changed column {ReactHtmlParser(act)}
                                                                  <br />
                                                                </p>
                                                              );
                                                            })
                                                        ) : (
                                                          <p>
                                                            {ReactHtmlParser(action.action)}
                                                            <br />
                                                          </p>
                                                        )}
                                                        {/* Changed column {ReactHtmlParser(action.action)} at{' '}  */}
                                                      </>
                                                    )}
                                                  </td>
                                                  <td>
                                                    {action.action.includes('Created this order') || action.action.includes('Created new order') ? (
                                                      <b>{new Date(action.createdAt).toLocaleString('en-GB')}</b>
                                                    ) : (
                                                      <b>{action.updated}</b>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </Table>
                                      </ModalBody>
                                    </Modal>
                                    {archive_priority_orders.length !== 0 && (
                                      <Col className='inner-custom-pagination d-flex mt-1'>
                                        <div className='d-inline'>
                                          <SizePerPageDropdownStandalone {...paginationProps} />
                                        </div>
                                        <div className='text-md-right ms-auto pagination pagination-rounded justify-content-end mb-2'>
                                          <PaginationListStandalone {...paginationProps} />
                                        </div>
                                      </Col>
                                    )}
                                  </Row>
                                  {alert}
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PriorityList.propTypes = {
  priority_orders: PropTypes.array,
  // boxSizes: PropTypes.array,
  // fees: PropTypes.array,
  onGetPriorityOrders: PropTypes.func,
  onGetArchivePriorityOrders: PropTypes.func,
  onGetSpecificPriorityOrders: PropTypes.func
  // onAddPriorityOrder: PropTypes.func,
  // onUpdatePriorityOrder: PropTypes.func,
  // onDeletePriorityOrder: PropTypes.func,
};

const mapStateToProps = ({ priority_orders }) => ({
  priority_orders: priority_orders.priority_orders,
  sl_managers: priority_orders.sl_managers,
  wh_managers: priority_orders.wh_managers,
  archive_priority_orders: priority_orders.archive_priority_orders,
  count: priority_orders.count,
  history_data: priority_orders.history_data,
  tr_agents: priority_orders.tr_agents,
  fees: priority_orders.fees,
  boxSizes: priority_orders.boxSizes,
  loading: priority_orders.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetPriorityOrders: () => dispatch(getPriorityOrders()),
  onGetArchivePriorityOrders: (priority_order) => dispatch(getArchivePriorityOrders(priority_order)),
  onGetSpecificPriorityOrders: (id) => dispatch(getSpecPriorityOrders(id)),
  onGetHistoryData: (priority_order) => dispatch(getHistoryData(priority_order)),
  // onAddPriorityOrder: (priority_order) => dispatch(addPriorityOrder(priority_order)),
  // onUpdatePriorityOrder: (priority_order) => dispatch(updatePriorityOrder(priority_order)),
  // onDeletePriorityOrder: (priority_order) => dispatch(deletePriorityOrder(priority_order)),
  // onAddTransfer: (transfer) => dispatch(addTransfer(transfer)),
  // onUpdateAgent: (transfer) => dispatch(updateAgent(transfer)),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PriorityList));
